import { addDays, dateKey, startOfLocalDay } from './dateUtils';
import {
  getStatewideHolidays,
  isHolidayDate
} from './holidayLogic';

function isStatewideHoliday(date) {
  const keys = getStatewideHolidays(date.getFullYear()).map(dateKey);

  return keys.includes(dateKey(date));
}

export function isPersonalSchoolDay(date, workdays, regionId) {
  const weekday = date.getDay();

  return workdays.includes(weekday)
    && !isHolidayDate(date, regionId)
    && !isStatewideHoliday(date);
}

export function countSchoolDays(now, targetDate, workdays, regionId) {
  if (!targetDate) return 0;

  let cursor = startOfLocalDay(now);
  let total = 0;

  while (cursor < targetDate) {
    const todayIsFinished = dateKey(cursor) === dateKey(now)
      && (now.getHours() > 15
        || (now.getHours() === 15 && now.getMinutes() >= 0));

    if (
      !todayIsFinished
      && isPersonalSchoolDay(cursor, workdays, regionId)
    ) {
      total += 1;
    }

    cursor = addDays(cursor, 1);
  }

  return total;
}

export function getMonthProgress(now) {
  const totalDays = new Date(
    now.getFullYear(),
    now.getMonth() + 1,
    0
  ).getDate();

  return Math.round((now.getDate() / totalDays) * 100);
}